import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mt-1" }
const _hoisted_2 = {
  key: 0,
  class: "mt-1 text-sm text-red-500"
}
const _hoisted_3 = { class: "mt-1 relative rounded-md shadow-sm" }
const _hoisted_4 = {
  key: 0,
  class: "mt-1 text-sm text-red-500"
}
const _hoisted_5 = { class: "mt-1" }
const _hoisted_6 = {
  key: 0,
  class: "mt-1 text-sm text-red-500"
}
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = { class: "space-y-1 text-center" }
const _hoisted_9 = { class: "flex text-sm text-gray-400" }
const _hoisted_10 = { class: "text-xs text-blue-400" }
const _hoisted_11 = {
  key: 1,
  class: "flex justify-center px-6 pt-5 pb-6 border-2 border-gray-600 border-dashed rounded-md bg-gray-800"
}
const _hoisted_12 = { class: "space-y-1 text-center" }
const _hoisted_13 = { class: "text-xs text-blue-400" }
const _hoisted_14 = {
  key: 2,
  class: "mt-1 text-sm text-red-500"
}
const _hoisted_15 = {
  key: 3,
  class: "image-gallery mt-4"
}
const _hoisted_16 = { class: "image-grid" }
const _hoisted_17 = { class: "image-container" }
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 0,
  class: "main-badge"
}
const _hoisted_20 = {
  key: 1,
  class: "existing-badge"
}
const _hoisted_21 = { class: "image-actions" }
const _hoisted_22 = { class: "action-buttons" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "flex space-x-4" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 0,
  class: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductCategoryDropdown = _resolveComponent("ProductCategoryDropdown")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
    class: "space-y-6"
  }, [
    _createElementVNode("div", null, [
      _cache[18] || (_cache[18] = _createElementVNode("label", {
        for: "product-name",
        class: "block text-sm font-medium text-gray-300"
      }, "Naslov oglasa *", -1)),
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          id: "product-name",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editableFormData.name) = $event)),
          type: "text",
          autocomplete: "off",
          placeholder: "Naziv proizvoda",
          class: _normalizeClass(["appearance-none block w-full px-3 py-2 border border-gray-700 rounded-md shadow-sm placeholder-gray-500 bg-gray-700 text-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm", { 'border-red-500': _ctx.errors.name }]),
          onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validateField('name'))),
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.syncField('name')))
        }, null, 34), [
          [_vModelText, _ctx.editableFormData.name]
        ]),
        (_ctx.errors.name)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.errors.name), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ProductCategoryDropdown, {
      modelValue: _ctx.editableFormData.categoryId,
      "onUpdate:modelValue": [
        _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editableFormData.categoryId) = $event)),
        _cache[5] || (_cache[5] = ($event: any) => (_ctx.syncField('categoryId')))
      ],
      error: _ctx.errors.categoryId,
      onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateField('categoryId')))
    }, null, 8, ["modelValue", "error"]),
    _createElementVNode("div", null, [
      _cache[20] || (_cache[20] = _createElementVNode("label", {
        for: "product-price",
        class: "block text-sm font-medium text-gray-300"
      }, "Cena (RSD) *", -1)),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          id: "product-price",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editableFormData.price) = $event)),
          type: "text",
          placeholder: "0.00",
          autocomplete: "off",
          class: _normalizeClass(["appearance-none block w-full px-3 py-2 border border-gray-700 rounded-md shadow-sm placeholder-gray-500 bg-gray-700 text-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm", { 'border-red-500': _ctx.errors.price }]),
          onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validateField('price'))),
          onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.formatPrice && _ctx.formatPrice(...args)))
        }, null, 34), [
          [_vModelText, _ctx.editableFormData.price]
        ]),
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" }, [
          _createElementVNode("span", { class: "text-gray-400 sm:text-sm" }, "RSD")
        ], -1)),
        (_ctx.errors.price)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.errors.price), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", null, [
      _cache[21] || (_cache[21] = _createElementVNode("label", {
        for: "product-description",
        class: "block text-sm font-medium text-gray-300"
      }, "Opis proizvoda *", -1)),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("textarea", {
          id: "product-description",
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editableFormData.description) = $event)),
          rows: "5",
          placeholder: "Detaljan opis proizvoda...",
          class: _normalizeClass(["appearance-none block w-full px-3 py-2 border border-gray-700 rounded-md shadow-sm placeholder-gray-500 bg-gray-700 text-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm", { 'border-red-500': _ctx.errors.description }]),
          onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.validateField('description'))),
          onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.syncField('description')))
        }, null, 34), [
          [_vModelText, _ctx.editableFormData.description]
        ]),
        (_ctx.errors.description)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.errors.description), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", null, [
      _cache[31] || (_cache[31] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-300" }, "Slike proizvoda", -1)),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.editableFormData.images.length < 12)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "flex justify-center px-6 pt-5 pb-6 border-2 border-gray-700 border-dashed rounded-md hover:border-gray-500 transition-colors cursor-pointer",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args))),
              onDragover: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["prevent"])),
              onDrop: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_8, [
                _cache[23] || (_cache[23] = _createElementVNode("svg", {
                  class: "mx-auto h-12 w-12 text-gray-400",
                  stroke: "currentColor",
                  fill: "none",
                  viewBox: "0 0 48 48",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("path", {
                    d: "M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_9, [
                  _cache[22] || (_cache[22] = _createElementVNode("p", { class: "pl-1" }, "Prevucite slike ovde ili kliknite za odabir", -1)),
                  _createElementVNode("input", {
                    ref: "fileInput",
                    type: "file",
                    accept: "image/*",
                    multiple: "",
                    class: "sr-only",
                    onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args)))
                  }, null, 544)
                ]),
                _cache[24] || (_cache[24] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "PNG, JPG, GIF do 10MB", -1)),
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.editableFormData.images.length) + "/12 slika ", 1)
              ])
            ], 32))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[25] || (_cache[25] = _createElementVNode("svg", {
                  class: "mx-auto h-12 w-12 text-gray-500",
                  stroke: "currentColor",
                  fill: "none",
                  viewBox: "0 0 48 48",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("path", {
                    d: "M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1)),
                _cache[26] || (_cache[26] = _createElementVNode("p", { class: "text-sm text-gray-500" }, " Dostigli ste maksimum od 12 slika ", -1)),
                _cache[27] || (_cache[27] = _createElementVNode("p", { class: "text-xs text-gray-500" }, " Uklonite neku sliku da biste dodali novu ", -1)),
                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.editableFormData.images.length) + "/12 slika ", 1)
              ])
            ])),
        (_ctx.errors.images)
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.errors.images), 1))
          : _createCommentVNode("", true),
        (_ctx.editableFormData.images.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editableFormData.images, (image, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "image-item"
                  }, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("img", {
                        src: image.preview,
                        style: _normalizeStyle({ transform: `rotate(${image.rotation || 0}deg)` }),
                        alt: "Preview"
                      }, null, 12, _hoisted_18),
                      (image.isMain)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Glavna"))
                        : _createCommentVNode("", true),
                      (image.isExisting)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, " Postojeća "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        (!image.isMain)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              onClick: _withModifiers(($event: any) => (_ctx.setMainImageWithSync(index)), ["stop"]),
                              class: "action-button blue"
                            }, _cache[28] || (_cache[28] = [
                              _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-5 w-5",
                                viewBox: "0 0 20 20",
                                fill: "currentColor"
                              }, [
                                _createElementVNode("path", { d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" })
                              ], -1)
                            ]), 8, _hoisted_23))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _withModifiers(($event: any) => (_ctx.rotateImageWithSync(index)), ["stop"]),
                          class: "action-button green"
                        }, _cache[29] || (_cache[29] = [
                          _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            class: "h-5 w-5",
                            viewBox: "0 0 20 20",
                            fill: "currentColor"
                          }, [
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              d: "M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z",
                              "clip-rule": "evenodd"
                            })
                          ], -1)
                        ]), 8, _hoisted_24),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _withModifiers(($event: any) => (_ctx.removeImageWithSync(index)), ["stop"]),
                          class: "action-button red"
                        }, _cache[30] || (_cache[30] = [
                          _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            class: "h-5 w-5",
                            viewBox: "0 0 20 20",
                            fill: "currentColor"
                          }, [
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              d: "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
                              "clip-rule": "evenodd"
                            })
                          ], -1)
                        ]), 8, _hoisted_25)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.cancelChanges && _ctx.cancelChanges(...args))),
        disabled: !_ctx.hasChanges,
        class: "w-1/2 py-2 px-4 border border-gray-500 rounded-md shadow-sm text-sm font-medium text-gray-300 bg-gray-700 hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 disabled:bg-gray-800 disabled:border-gray-700 disabled:text-gray-500 disabled:cursor-not-allowed"
      }, " Otkaži izmene ", 8, _hoisted_27),
      _createElementVNode("button", {
        type: "submit",
        disabled: _ctx.isLoading || !_ctx.hasChanges,
        class: "w-1/2 flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-indigo-400 disabled:cursor-not-allowed"
      }, [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_29, _cache[32] || (_cache[32] = [
              _createElementVNode("circle", {
                class: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                "stroke-width": "4"
              }, null, -1),
              _createElementVNode("path", {
                class: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              }, null, -1)
            ])))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.isLoading
            ? 'Obrada...'
            : _ctx.hasChanges
            ? 'Sačuvaj izmene'
            : 'Nema izmena'), 1)
      ], 8, _hoisted_28)
    ])
  ], 32))
}